import Vue from 'vue';
import VueI18n from 'vue-i18n';

// import various translations here
// import {en} from '@/translations/en.js'
// import {da} from '@/translations/da.js'
import en from '@/translations/en.json'
import da from '@/translations/da.json'
import fr from '@/translations/fr.json'
import de from '@/translations/de.json'

Vue.use(VueI18n)

export const i18n = new VueI18n ({
  locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
  fallbackLocale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en',
  // map which file will serve for which locale
  messages: { en: en, da: da, fr: fr, de: de }
})
